import {
    Autocomplete,
    Box, Button, Drawer,
    Stack, TextField, Tooltip, Typography
} from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import '../reports.css';
import { CommonGridToolBarWithFilterText } from "../../../../Components/Common Components/CommonComponents";
import { ImagePaths } from '../../../../Utility/ImagePaths';
import CommonDatePicker from '../../../../Components/Common Components/CommonDatePicker';
import RestAPIService from '../../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import { formatDate } from "../../../../Components/CommonFunctions/CommonFunctions";
import { DateTime } from 'luxon';
import { getCachevalue } from '../../../../Utility/Services/CacheProviderService';
import { AmountsCard } from '../../../../Components/CommonCards/CommonCards';
import { Colors } from '../../../../Styles/Colors';


class OpthoSurgeryReport extends Component {

    constructor(props) {
        super(props)
        this.state = {
            page: 0,
            pageSize: 10,
            fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
            toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
            dateIndex: 1,
            surgeryReportData: [],
            total_surgery: 0,
            clinic_id: getCachevalue('SelectedDoctorClinic'),
            surgerySugg: [],
            packageSugg: [],
            selectedSurgery: null,
            selectedPackage: null,
            FilterOpen: false,
            isLoader: false,
            printLoad: false
        }
    }

    componentDidMount() {
        this.getSurgeryList()
        this.getSurgeryReportData()
    }

    errorMessage = (message) => {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: message
        })
    }

    msgClose() {
        this.setState({
            isErrorMsg: false,
            isErrorMsgText: '',
        })
    }

    FilterDate = (from, to, index) => {
        this.setState({
            fromDate: from,
            toDate: to,
            dateIndex: index
        })
    }

    getSurgeryList = () => {
        try {
            RestAPIService.getAll(Serviceurls.DOC_DOCTOR_NOTES_COUNSELLING_SURGERY_SEARCH + '?clinic_id=' + this.state.clinic_id)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        this.setState({ surgerySugg: response?.data?.data })
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        this.errorMessage(error?.response?.data?.message)
                    } else {
                        this.errorMessage(error.message)
                    }
                })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    getPackageList = (search) => {
        try {
            RestAPIService.getAll(Serviceurls.DOC_DOCTOR_NOTES_COUNSELLING_SURGERY_SEARCH +
                '?surgery_key=' + search + '&clinic_id=' + this.state.clinic_id)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        this.setState({ packageSugg: response?.data?.data })
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        this.errorMessage(error?.response?.data?.message)
                    } else {
                        this.errorMessage(error.message)
                    }
                })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    getSurgeryReportData = () => {
        try {
            this.setState({ isLoader: true })
            let surgeryName = this.state.selectedSurgery || ''
            let packageName = this.state.selectedPackage || ''
            RestAPIService.getAll(Serviceurls.NEW_DOC_SURGERY_REPORT +
                '?surgery_name=' + surgeryName +
                '&package_name=' + packageName +
                '&from_date=' + this.state.fromDate +
                '&to_date=' + this.state.toDate +
                '&clinic_id=' + this.state.clinic_id
            )
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        this.setState({ surgeryReportData: response?.data?.data, isLoader: false })
                    }
                }).catch((error) => {
                    this.setState({ isLoader: false })
                    if (error?.response?.data?.message) {
                        this.errorMessage(error?.response?.data?.message)
                    } else {
                        this.errorMessage(error.message)
                    }
                })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    getSurgeryReportPrint = () => {
        try {
            let surgeryName = this.state.selectedSurgery || ''
            let packageName = this.state.selectedPackage || ''
            RestAPIService.getAll(Serviceurls.NEW_DOC_SURGERY_REPORT +
                '?surgery_name=' + surgeryName +
                '&package_name=' + packageName +
                '&from_date=' + this.state.fromDate +
                '&to_date=' + this.state.toDate +
                '&clinic_id=' + this.state.clinic_id +
                '&export_type=pdf'
            ).then((response) => {
                if (response) {
                    //Create a Blob from the PDF Stream
                    const file = new Blob(
                        [response.data],
                        { type: 'application/pdf' });
                    //Build a URL from the file
                    const fileURL = URL.createObjectURL(file);
                    //Open the URL on new Window
                    window.open(fileURL);
                    this.setState({ printLoad: false })
                }
            }).catch((error) => {
                this.setState({ printLoad: false })
                if (error?.response?.data?.message) {
                    this.errorMessage(error?.response?.data?.message)
                } else {
                    this.errorMessage(error.message)
                }
            })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    renderFilterScreen = () => {
        const { t } = this.props;
        return (
            <Box component={"div"} className='eMed_rts_filter_container'>
                <Box component={"div"} className='eMed_filter_Top'>
                    <Typography variant='h6' fontWeight={600}>{t("Filter")}</Typography>
                    <Button onClick={() => { this.setState({ FilterOpen: false }) }} className='eMed_usrconf_btn'>
                        <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
                    </Button>
                </Box>
                <Box className='eMed_rts_middle'>
                    <Box className='eMed_date_filter'>
                        <CommonDatePicker
                            FromDate={this.state.fromDate}
                            ToDate={this.state.toDate}
                            DateIndex={this.state.dateIndex}
                            SelectedDates={this.FilterDate.bind(this)}
                            HideAllMenu={true} />
                    </Box>
                    <Box className='eMed_rts_dropdown'>
                        <Autocomplete
                            clearIcon
                            size='small'
                            fullWidth
                            options={this.state.surgerySugg || []}
                            getOptionLabel={(option) => typeof (option) === 'string' ? option : option.surgery_key}
                            value={this.state.selectedSurgery}
                            onChange={(e, newValue) => {
                                this.setState({ selectedSurgery: newValue?.surgery_key }, () => {
                                    if (this.state.selectedSurgery) {
                                        this.getPackageList(this.state.selectedSurgery)
                                    } else {
                                        this.setState({ packageSugg: [] })
                                    }
                                })
                            }}
                            renderInput={(params) => <TextField
                                {...params}
                                label='Select Surgery Name'
                            />}
                        />
                    </Box>
                    <Box className='eMed_rts_dropdown'>
                        <Autocomplete
                            clearIcon
                            size='small'
                            fullWidth
                            options={this.state.packageSugg || []}
                            getOptionLabel={(option) => typeof (option) === 'string' ? option : option.package_name}
                            value={this.state.selectedPackage}
                            onChange={(e, newValue) => {
                                this.setState({ selectedPackage: newValue?.package_name })
                            }}
                            renderInput={(params) => <TextField
                                {...params}
                                label='Select Package Name'
                            />}
                        />
                    </Box>
                </Box>
                <Stack spacing={2} direction="row" className='eMed_rts_btn' alignItems="center" justifyContent="center">
                    <Button variant='outlined' size="small"
                        onClick={() => {
                            this.setState({
                                fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                                toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                                dateIndex: 1,
                                selectedSurgery: null,
                                selectedPackage: null,
                                packageSugg: [],
                                FilterOpen: false
                            }, () => this.getSurgeryReportData())
                        }}
                        id="eMed_Config_btn">{t("Clear")}</Button>
                    <Button variant='contained' size="small"
                        onClick={() => {
                            this.setState({ isLoader: true }, () => {
                                this.getSurgeryReportData()
                            })
                            this.closeFilter()
                        }}
                        id="eMed_Config_btn">{t("Search")}</Button>
                </Stack>
            </Box>
        )
    }

    gridToolBar = () => {
        var { t } = this.props
        let TextArray = [
            { label: "From Date", value: formatDate(this.state.fromDate) },
            { label: "To Date", value: formatDate(this.state.toDate) },
        ]
        return (
            <Box>
                <CommonGridToolBarWithFilterText FilterTextArray={TextArray} />
            </Box>

        )
    }

    closeFilter = () => {
        this.setState({ FilterOpen: false })
    }

    render() {
        this.state.surgeryReportData?.forEach((element, index) => element.sno = index + 1);
        const { t } = this.props;
        const columns = [
            {
                field: 'patient_details', headerName: 'Patient Details', flex: 0.166,
                renderCell: (params) => {
                    let patientName = `${params?.row?.patient_name} ${params?.row?.patient_age}/${params?.row?.patient_gender?.toUpperCase()}`
                    let mobUhid = `${params?.row?.patient_account_number} | ${params?.row?.mobile_no}`
                    return (
                        <Box component={'div'}>
                            {patientName ? patientName?.length > 30 ?
                                <Tooltip placement='top' title={patientName}><Typography fontSize={'0.9rem'} fontWeight={600}>{patientName?.slice(0, 30) + '...'}</Typography></Tooltip> :
                                <Typography fontSize={'0.9rem'} fontWeight={600}>{patientName}</Typography> : '-'}
                            {mobUhid ? mobUhid?.length > 30 ?
                                <Tooltip placement='top' title={mobUhid}><Typography fontSize={'0.8rem'} color={Colors.grayShade}>{mobUhid?.slice(0, 30) + '...'}</Typography></Tooltip> :
                                <Typography fontSize={'0.8rem'} color={Colors.grayShade}>{mobUhid}</Typography> : '-'}
                        </Box>
                    )
                }
            },
            {
                field: 'surgery_name', headerName: 'Surgery Name', flex: 0.166,
                renderCell: (params) => {
                    let surgeryName = `${params?.row?.surgery_name}`
                    return (
                        <Box component={'div'}>
                            {surgeryName ? surgeryName?.length > 20 ?
                                <Tooltip placement='top' title={surgeryName}><Typography fontSize={'1rem'}>{surgeryName?.slice(0, 20) + '...'}</Typography></Tooltip> :
                                <Typography fontSize={'1rem'}>{surgeryName}</Typography> : '-'}
                        </Box>
                    )
                }
            },
            {
                field: 'package_name', headerName: 'Package Name', flex: 0.166,
                renderCell: (params) => {
                    let packageName = `${params?.row?.package_name}`
                    return (
                        <Box component={'div'}>
                            {packageName ? packageName?.length > 20 ?
                                <Tooltip placement='top' title={packageName}><Typography fontSize={'1rem'}>{packageName?.slice(0, 20) + '...'}</Typography></Tooltip> :
                                <Typography fontSize={'1rem'}>{packageName}</Typography> : '-'}
                        </Box>
                    )
                }
            },
            {
                field: 'eye_type', headerName: 'Eye Type', flex: 0.166,
                renderCell: (params) => {
                    let eyeType = `${params?.row?.eye_type}`
                    return (
                        <Box component={'div'}>
                            {eyeType ? eyeType?.length > 20 ?
                                <Tooltip placement='top' title={eyeType}><Typography fontSize={'1rem'}>{eyeType?.slice(0, 20) + '...'}</Typography></Tooltip> :
                                <Typography fontSize={'1rem'}>{eyeType}</Typography> : '-'}
                        </Box>
                    )
                }
            },
            {
                field: 'surgery_date', headerName: 'Surgery Date & Time', flex: 0.166,
                renderCell: (params) => {
                    let dateTime = `${params?.row?.surgery_date}`
                    return (
                        <Box component={'div'}>
                            {dateTime ? dateTime?.length > 20 ?
                                <Tooltip placement='top' title={dateTime}><Typography fontSize={'1rem'}>{dateTime?.slice(0, 20) + '...'}</Typography></Tooltip> :
                                <Typography fontSize={'1rem'}>{dateTime}</Typography> : '-'}
                        </Box>
                    )
                }
            },
            {
                field: 'surgeon_name', headerName: 'Surgeon Name', flex: 0.166,
                renderCell: (params) => {
                    let surgeonName = `${params?.row?.surgeon_name}`
                    return (
                        <Box component={'div'}>
                            {surgeonName ? surgeonName?.length > 20 ?
                                <Tooltip placement='top' title={surgeonName}><Typography fontSize={'1rem'}>{surgeonName?.slice(0, 20) + '...'}</Typography></Tooltip> :
                                <Typography fontSize={'1rem'}>{surgeonName}</Typography> : '-'}
                        </Box>
                    )
                }
            },
        ]
        return (
            <Box component={'div'} className='eMed_rts_container'>
                <Box component={"div"} className='eMed_Top_Container'>
                    <Box component={"div"} className='eMed_Cards_Container'>
                        {AmountsCard(t("No of Surgery"), this.state.total_surgery, true)}
                    </Box>
                    <Box component={"div"} className='eMed_Action_Container'>
                        <Box component={"div"} className='eMed_Filter_Icon_div'>
                            <Button className='eMed_usrconf_btn' onClick={() => { this.setState({ FilterOpen: true }) }}>
                                <img src={ImagePaths.Filter.default} alt="filter" className='eMed_action_img' />
                            </Button>
                        </Box>
                        <Button className='eMed_usrconf_btn'
                            disabled={this.state.printLoad}
                            onClick={() => { this.setState({ printLoad: true }, () => this.getSurgeryReportPrint()) }}>
                            <img src={ImagePaths.LabPrintIcon.default} alt="print" className='eMed_action_img' />
                        </Button>
                    </Box>
                </Box>
                <Box component={'div'} className='eMed_rts_table'>
                    <DataGrid
                        rows={this.state.surgeryReportData || []}
                        columns={columns || []}
                        getRowId={(row) => row.sno}
                        page={this.state.page}
                        pageSize={this.state.pageSize}
                        localeText={{
                            toolbarColumns: "",
                            toolbarDensity: "",
                            toolbarExport: "",
                            toolbarFilters: "",
                            toolbarExportPrint: ""
                        }}
                        components={{
                            Toolbar: this.gridToolBar,
                            NoRowsOverlay: () => (
                                <Stack className='eMed_conf_nodata'>
                                    {t("NoRecordsFound")}
                                </Stack>
                            )
                        }}
                        onPageChange={(newPage) => { this.setState({ page: newPage }) }}
                        onPageSizeChange={(newPageSize) => this.setState({ pageSize: newPageSize })}
                        rowsPerPageOptions={[10, 20, 30]}
                        pagination
                        headerHeight={40}
                        disableSelectionOnClick
                        loading={this.state.isLoader}
                    />
                </Box>
                <Drawer
                    anchor={'right'}
                    open={this.state.FilterOpen}
                    ModalProps={{ onBackdropClick: this.closeFilter }}
                >
                    {this.renderFilterScreen()}
                </Drawer>
                {this.state.isErrorMsg ?
                    <ToastMsg
                        severity={'error'}
                        msg={this.state.isErrorMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
            </Box>
        )
    }
}
export default withTranslation()(OpthoSurgeryReport)